"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewSite extends new_item_1.default {
    constructor(newSite) {
        super();
        if (!newSite.name) {
            throw Error("name required");
        }
        this.name = newSite.name;
        this.groupTypeId = newSite.groupTypeId;
        this.timezone = newSite.timezone;
        this.dataTypes = newSite.dataTypes;
        this.organisationId = newSite.organisationId;
        this.tariffIds = newSite.tariffIds;
        this.address = newSite.address;
        this.totalDemand = newSite.totalDemand;
        this.widgetBoardId = newSite.widgetBoardId;
        this.locationId = newSite.locationId;
        this.locationName = newSite.locationName;
        this.lat = newSite.lat;
        this.lng = newSite.lng;
        this.locationMetadata = newSite.locationMetadata;
        this._permission = newSite._permission;
        this.gateways = newSite.gateways;
        this.issues = newSite.issues;
        this.issueIds = newSite.issueIds;
        this.customFields = newSite.customFields;
        this.deviceList = newSite.deviceList;
        this.occupancyScheduleId = newSite.occupancyScheduleId;
        this.occupancyScheduleName = newSite.occupancyScheduleName;
        this.occupancySchedule = newSite.occupancySchedule;
        this.defaultOccupancyScheduleId = newSite.defaultOccupancyScheduleId;
        this.defaultOccupancyScheduleName = newSite.defaultOccupancyScheduleName;
        this.defaultOccupancySchedule = newSite.defaultOccupancySchedule;
        this.disconnectedAssetsViaHub = newSite.disconnectedAssetsViaHub;
        this.lowBatteryAssets = newSite.lowBatteryAssets;
        this.appliances = newSite.appliances;
        this.lowSignalAssets = newSite.lowSignalAssets;
        this.assetsWithIssues = newSite.assetsWithIssues;
        this.faultyAssets = newSite.faultyAssets;
        this.intermittentAssets = newSite.intermittentAssets;
        this.anomalousAssets = newSite.anomalousAssets;
        this.defaultModifiers = newSite.defaultModifiers;
    }
}
exports.default = NewSite;
//# sourceMappingURL=new-site.js.map